import { supabase } from "@/integrations/supabase/client";

/**
 * AI Merge Service - Handles AI-powered field merging using Supabase edge function
 */
export class AIMergeService {
	/**
	 * AI merge functionality using the ai-merge edge function
	 * Takes an array of values and returns the AI-merged result
	 */
	static async mergeValues(values: any[], entityType: string = 'unknown'): Promise<string> {
		//console.log(`AI Merge requested:`, values);
		
		// Filter out empty/null values and convert to strings
		const nonEmptyValues = values
			.filter(v => v !== null && v !== undefined && String(v).trim() !== '')
			.map(v => String(v));
		
		// If we only have one non-empty value, return it directly
		if (nonEmptyValues.length <= 1) {
			return nonEmptyValues[0] || '';
		}
				try {
			const { data, error } = await supabase.functions.invoke('ai-merge', {
				body: {
					texts: nonEmptyValues,
					entity: entityType
				}
			});
			
			if (error) {
				console.error('Error calling ai-merge function:', error);
				// Fallback to simple concatenation
				return nonEmptyValues.join('\n\n---\n\n');
			}
			
			return data.fusedText || '';
			
		} catch (error) {
			console.error('Error in AI merge:', error);
			// Fallback to simple concatenation
			return nonEmptyValues.join('\n\n---\n\n');
		}
	}
}
